module.exports = __webpack_public_path__ + "static/media/M003-account-noprivilege.8c6a31b7.svg";